import { Typography, Layout, Button, Image, Dropdown, Menu } from "antd";
import {
  BiLogoLinkedin,
  BiLogoYoutube,
  BiLogoInstagram,
} from "react-icons/bi";
import IconXTwitter from "../icons/IconXTwitter";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Functions";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt, FaArrowRight } from "react-icons/fa";
import { HiShieldCheck } from "react-icons/hi2";

import "./ClientFooter.css";

const { Footer } = Layout;

const SERVICE_LINKS = [
  { label: "Trainers", to: "https://trainer.wrightcoacademy.com/signin", external: true },
  { label: "Head Start", to: "/courses" },
  { label: "Early Head Start", to: "/courses" },
  { label: "Day Care", to: "/courses" },
  { label: "Family Child Care", to: "/courses" },
];

const CONSULTING_LINKS = [
  { label: "Terms & Conditions", to: "/termsandconditions" },
  { label: "Privacy Policy", to: "/privacyPolicy" },
  { label: "Terms Of Service", to: "/termsOfService" },
  { label: "Refund Policy", to: "/refundPolicy" },
];

const NAV_LINKS = [
  { key: "home", label: "Home", to: "/" },
  { key: "about", label: "About", to: "/about-us" },
  { key: "services", label: "Services", to: "/courses" },
  { key: "book_online", label: "Book Online", to: "/pricingPlans" },
  { key: "contact_us", label: "Contact Us", to: "/contact-us" },
  { key: "disclaimer", label: "Disclaimer", to: "/disclaimer" },
];

const ClientFooter = () => {
  const navigate = useNavigate();

  const footerRegisterDrop = (
    <Menu
      items={[
        {
          key: "1",
          label: "Register as Student",
          onClick: () => navigate("/signup"),
        },
        {
          key: "2",
          label: (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://trainer.wrightcoacademy.com/signup"
            >
              Register as Trainer
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://wrightcoacademy.com/request"
            >
              Register as Enterprise
            </Link>
          ),
        },
      ]}
    />
  );

  return (
    <Footer className="footer client-footer">
      <div className="client-footer__outer">
        <div className="client-footer__grid">
          <section className="client-footer__block client-footer__block--brand">
            <div className="client-footer__brand-logo-wrap">
              <Image
                preview={false}
                alt="WrightCo Academy"
                height={72}
                src={ImageUrl("logo-header 1.png")}
                style={{ maxWidth: "100%", cursor: "pointer" }}
                onClick={() => navigate("/")}
              />
            </div>
            <p className="client-footer__slogan">
              Leading Environmental Change in Early Care and Education
            </p>
            <Typography.Text className="fontFamily1 client-footer__text">
              We&apos;re a passionate group of educators working together to
              create the best online learning experiences for adult learners
              like you.
            </Typography.Text>
            <div className="client-footer__social-row">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="client-footer__social-btn"
                aria-label="LinkedIn"
              >
                <BiLogoLinkedin aria-hidden="true" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="client-footer__social-btn"
                aria-label="X"
              >
                <IconXTwitter aria-hidden="true" />
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="client-footer__social-btn"
                aria-label="YouTube"
              >
                <BiLogoYoutube aria-hidden="true" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="client-footer__social-btn"
                aria-label="Instagram"
              >
                <BiLogoInstagram aria-hidden="true" />
              </a>
            </div>
            <div className="client-footer__cta-row">
              <Dropdown overlay={footerRegisterDrop} trigger={["click"]}>
                <Button type="primary" className="client-footer__cta" size="large">
                  Register Now <FaArrowRight aria-hidden="true" />
                </Button>
              </Dropdown>
              <Button
                className="client-footer__cta-outline"
                size="large"
                onClick={() => navigate("/signup")}
              >
                Apply Now
              </Button>
            </div>
          </section>

          <section className="client-footer__block">
            <Typography.Title level={4} className="fontFamily1 client-footer__heading">
              Services
            </Typography.Title>
            <ul className="client-footer__list">
              {SERVICE_LINKS.map((item) => (
                <li key={item.label} className="client-footer__list-item">
                  {item.external ? (
                    <a
                      href={item.to}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.to}>{item.label}</Link>
                  )}
                </li>
              ))}
            </ul>

            <Typography.Title
              level={4}
              className="fontFamily1 client-footer__heading client-footer__heading--spaced"
            >
              Consulting
            </Typography.Title>
            <ul className="client-footer__list">
              {CONSULTING_LINKS.map((item) => (
                <li key={item.label} className="client-footer__list-item">
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </section>

          <section className="client-footer__block">
            <Typography.Title level={4} className="fontFamily1 client-footer__heading">
              Navigation
            </Typography.Title>
            <ul className="client-footer__nav-list">
              {NAV_LINKS.map(({ key, label, to }) => (
                <li key={key}>
                  <Link to={to} className="client-footer__nav-link fontFamily1">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>

          <section className="client-footer__block client-footer__block--contact">
            <Typography.Title level={4} className="fontFamily1 client-footer__heading">
              Get In Touch
            </Typography.Title>
            <ul className="client-footer__contact-list">
              <li>
                <FaLocationDot className="client-footer__contact-icon" aria-hidden="true" />
                <a
                  href="https://www.google.com/maps?q=1000+Front+St+%23147,+Uniondale,+NY+11553,+USA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  1000 Front St #147, Uniondale, NY 11553, USA
                </a>
              </li>
              <li>
                <MdEmail className="client-footer__contact-icon" aria-hidden="true" />
                <a href="mailto:support@wrightcoacademy.com">
                  support@wrightcoacademy.com
                </a>
              </li>
              <li>
                <FaPhoneAlt className="client-footer__contact-icon" aria-hidden="true" />
                <a href="tel:+18777012899">+877-701-2899</a>
              </li>
            </ul>
          </section>
        </div>

        <div className="client-footer__bottom">
          <div className="client-footer__trust">
            <span className="client-footer__trust-icon" aria-hidden="true">
              <HiShieldCheck />
            </span>
            <div>
              <p className="client-footer__trust-title">
                Trusted. Professional. Impactful.
              </p>
              <p className="client-footer__trust-sub">
                Empowering educators. Inspiring change.
              </p>
            </div>
          </div>
          <p className="client-footer__copy">
            WrightCo Academy™. All Rights Reserved.
          </p>
          <div className="client-footer__legal">
            <Link to="/termsandconditions">Terms &amp; Conditions</Link>
            <span>|</span>
            <Link to="/privacyPolicy">Privacy Policy</Link>
            <span>|</span>
            <Link to="/faq">Sitemap</Link>
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default ClientFooter;
